module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/engine.io-parser/~/isarray/index.js
// module id = ../../../../engine.io-parser/node_modules/isarray/index.js
// module chunks = 3